<form>
  <div class="row">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive our-table">
        <table class="table table-striped text-nowrap mb-0">
          <thead class="border-top">
            <tr>
              <th scope="col" class="text-capitalize">
                {{ "common.creationDate" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.updateDate" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.transactionId" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.endToEndId" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.type" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.status" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.value" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.generatorDocument" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.payerDocument" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.userName" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-bottom" *ngFor="let transaction of transactions">
              <td>
                <span>{{
                  transaction.data | date : "dd/MM/yyyy HH:mm:ss" : "GMT"
                }}</span>
              </td>
              <td>
                <span>{{
                  transaction.dataUpdate | date : "dd/MM/yyyy HH:mm:ss" : "GMT"
                }}</span>
              </td>
              <td>
                <span>{{ transaction.id }}</span>
              </td>
              <td>
                <span>{{ transaction.endToEndId }}</span>
              </td>
              <td>
                <span>{{ transaction.type }}</span>
              </td>
              <td>
                <span
                  class="status-badge status-cap"
                  [ngClass]="formatStatusClass(transaction.status)"
                  >{{ transaction.status }}</span
                >
              </td>
              <td>
                <span>{{ transaction.value | formatCurrency }}</span>
              </td>
              <td>
                <span>
                  {{ transaction.document | mask : "CPF_CNPJ" }}
                </span>
              </td>
              <td>
                <span>
                  {{ transaction.payerdocument | mask : "CPF_CNPJ" }}
                </span>
              </td>
              <td>
                <span>{{ transaction.Name }}</span>
              </td>
            </tr>
            <tr *ngIf="transactions.length == 0">
              <td colspan="14">{{ "common.noData" | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between p-2">
        <ngb-pagination
          [collectionSize]="total"
          [maxSize]="5"
          [rotate]="true"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="pageChange()"
        >
        </ngb-pagination>
      </div>
    </div>
  </div>
</form>
